<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>Library resource</h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard</router-link>
                  \ Library resource
                </div>
              </div>

            </div>
          </div>
          <div class="card-body">
            <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
              <div class="row">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                      class="form-control"
                      v-model="search.name"
                      label="Search by title."
                      outlined
                      clearable
                      @input="search.name = $event !== null ? $event : ''"
                      v-on:keyup.enter="getAllTeacherResource()"
                      dense>
                  </v-text-field>
                </v-col>
                <div class="col-md-2">

                  <v-select outlined
                            :items="programs"
                            v-model="search.program_id"
                            @change="getGrades"
                            dense clearable
                            item-text="title"
                            item-value="id"
                            label="Program">
                  </v-select>

                </div>
                <div class="col-md-2" v-show="search.program_id">

                  <v-select
                      outlined
                      :items="gradesLevels"
                      v-model="search.grade_id"
                      dense
                      item-text="title"
                      item-value="id"
                      label="Semester/Year"
                  >
                  </v-select>
                </div>
                <v-col cols="12" md="12" class="text-right">
                  <v-btn
                      :loading="isLoading"
                      @click.prevent="getAllTeacherResource()"
                      class="btn btn-primary w-35 float-right"
                      dark
                  >
                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                    Search
                  </v-btn>
                </v-col>
              </div>
            </div>
            <div class="">
              <v-skeleton-loader
                  type="table-thead"
                  v-if="isLoading"
              >
              </v-skeleton-loader>

              <v-skeleton-loader
                  v-if="isLoading"
                  type="table-row-divider@25"
              >
              </v-skeleton-loader>
              <table class="table" v-if="!isLoading">
                <thead>
                <tr class="px-3">
                  <th class="px-3" style="max-width: 150px !important; white-space: pre-wrap;">Title</th>
                  <th class="px-3">Thesis</th>
                  <th class="px-3">Available attachment</th>
                  <th class="px-3">Status</th>
                  <th class="pr-3 text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="(resource,index) in resources" :key="index">
                    <td class="px-3" style="max-width: 300px !important; white-space: pre-wrap;">
                      <a @click="openResourceSummary(resource)" class="mr-2 font-weight-bold">
                        {{ resource.title }}
                      </a>
                    </td>
                    <td class="px-3">
                          <span>
                            <v-icon small :color="resource.is_thesis ?'#0abb87':'red'" :class="resource.is_thesis ?'fas fa-check':'fas fa-ban'">
                            </v-icon>
                          </span>
                    </td>
                    <td class="px-3">
                      <span>
                          <v-badge color="green" :content="resource.available_attachments" v-if="resource.available_attachments > 0"></v-badge>
                          <v-badge color="green" content="0" v-else></v-badge>
                      </span>
                    </td>
                    <td class="px-3 ">
                      <div class="mt-2">
                          <span class="badge badge-success text-lg "
                                v-bind:class="{ 'badge-success': resource.is_active, 'badge-danger': !resource.is_active }">
                            {{ resource.is_active ? 'Active' : 'Inactive' }}
                          </span>
                      </div>

                    </td>
                    <td class="pr-0 text-center">
                      <template>
                        <b-dropdown
                            size="sm"
                            variant="link"
                            toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                            no-caret
                            right
                            no-flip
                        >
                          <template v-slot:button-content>
                            <i class="ki ki-bold-more-hor"></i>
                          </template>
                          <!--begin::Navigation-->
                          <div class="navi navi-hover">
                            <b-dropdown-text tag="div" class="navi-item">
                              <a class="navi-link" @click="openResourceSummary(resource)">
                                  <span class="navi-icon">
                                      <i class="fas fa-eye"></i>
                                  </span>
                                <span class="navi-text">View</span>
                              </a>
                            </b-dropdown-text>
                          </div>
                        </b-dropdown>

                      </template>
                    </td>
                  </tr>
                  <tr v-if="resources.length==0">
                    <td colspan="4" class="text-center">
                      <strong>No items found.</strong>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
      <v-dialog v-model="dialog" max-width="900" scrollable>
            <v-card v-if="resourceDetail">

              <v-toolbar dark>
                <v-card-title class="headline">
                  {{resourceDetail.title || null}}
                  <hr>
                </v-card-title>

                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-btn icon  @click="closeDialog">
                    <i class="fas fa-times"></i>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text v-if="resourceDetail">
                <v-container>
                  <v-list rounded>

                    <v-list-item-group

                        color="primary"
                    >
                      <v-list-item v-show="resourceDetail && resourceDetail.attachments.length > 0"
                          v-for="(attachment, index) in resourceDetail.attachments"
                          :key="index"
                      >
                        <v-list-item-icon>
                          <v-icon v-text="`mdi-folder`"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <span class="font-weight-bold" v-if="!attachment.is_downloadable">
                              {{attachment.title}}
                            </span>
                            <a @click="openAttachmentFile(attachment.display_path)" class="font-weight-bold" v-if="attachment.is_downloadable">
                              {{attachment.title}}
                            </a>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <span class="font-weight-bold h6" v-show="resourceDetail.attachments.length == 0">
                        No resource available.
                      </span>
                    </v-list-item-group>
                  </v-list>
                </v-container>
              </v-card-text>
            </v-card>
      </v-dialog>

    </div>
  </v-app>
</template>
<script>
import ResourceService from "@/core/services/library/resource/ResourceService";
import GeneralMixin from "@/mixins/GeneralMixin";
import {SiteSettingMixin} from "@/mixins/SiteSettingMixin";
const resourceService=new ResourceService;
export default {
  mixins: [GeneralMixin,SiteSettingMixin],
  data(){
    return{
      dialog:false,
      search:{
        name:null,
        program_id:null,
        grade_id:null,
      },
      isLoading:false,
      resources:[],
      page: null,
      total: 0,
      totalPage: null,
      perPage: 25,
      resourceDetail:null,

    }
  },
  methods:{

    getAllTeacherResource(){
      resourceService
          .getAllTeacherResources(this.search,this.page)
          .then((response) => {
            this.resources=response.data.resources;
          })
          .catch(err => {

          })
          .finally(() => (this.isLoading = false))
    },
    closeDialog(){
      this.dialog=false;
      this.resourceDetail=null;
    },
    openDialog(){
      this.dialog=true;
    },
    openResourceSummary(item){
      this.resourceDetail=item;
      this.openDialog();

    },
    openAttachmentFile(display_path){
      if(display_path){
        window.open(display_path, '_blank');
      }
    },
  },
  mounted() {
    if(this.checkTeacherMenuAccess('library_resource')==false ){
      this.$router.push({name: '404'})
    }
    this.getPrograms();
    this.getAllTeacherResource();
  }
}
</script>